import { render, staticRenderFns } from "./excitingRecordItem.vue?vue&type=template&id=4cbfc6de&scoped=true"
import script from "./excitingRecordItem.vue?vue&type=script&lang=js"
export * from "./excitingRecordItem.vue?vue&type=script&lang=js"
import style0 from "./excitingRecordItem.vue?vue&type=style&index=0&id=4cbfc6de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbfc6de",
  null
  
)

export default component.exports